/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_From_Your_EmailInputs */

const en_common_from_your_email = /** @type {(inputs: Common_From_Your_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From your email`)
};

const es_common_from_your_email = /** @type {(inputs: Common_From_Your_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde tu correo`)
};

/**
* | output |
* | --- |
* | "From your email" |
*
* @param {Common_From_Your_EmailInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_from_your_email = /** @type {((inputs?: Common_From_Your_EmailInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_From_Your_EmailInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_from_your_email(inputs)
	return en_common_from_your_email(inputs)
});